<template>
  <div :style="isMinimize?'display:none':''" class="word-wrap">
    <el-dialog
      :visible.sync="isShow"
      width="650px"
      custom-class="aiUploadIELTS-box"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="11vh"
      >
      <span slot="title">
        <span>{{dialogTitle}}</span>
        <slot name="title"></slot>
      </span>
      <div class="word-wrap">
        <el-upload
          class="upload-file mb8"
          action="/appFile/uploadStudentAiFile"
          :before-upload="beforeUpload"
          :on-success="successUpload"
          :drag="true"
          :show-file-list="false"
          :multiple="true"
          name="files"
          :data="uploadData"
          :headers="{
            at:at
          }"
          >
          <div class="drag-box text-color1 flex-center">
            <div>
              <img :src="image.upload" alt="">
            </div>
            <div>
              <p class="mb8">{{t('ai.tips3')}}<span class="themeColor">{{t('ai.tips4')}}</span></p>
              <p class="mb8 text-color2 fs12">{{t('ai.tips1')}}</p>
              <p class="text-color2 fs12 mb8">{{t('ai.tips2')}}{{filesType.toString()}}</p>
              <p class="text-color2 fs12">{{t('ai.tips13')}}</p>
              <p class="text-color2 fs12 mb8">{{t('ai.tips14')}}</p>
              <p class="text-color2 fs12">{{t('ai.tips9')}}</p>
            </div>
          </div>
        </el-upload>
        <div class="file-result">
          <div class="todo-tab mb8 flex-center flex-space-between" v-if="moduleType==='ALL'">
            <div>
              <el-button size="small" :type="tabActive===1?'primary':''" @click="handleTab(1)">{{t('ai.identificationProgress')}}</el-button>
              <el-button size="small" :type="tabActive===2?'primary':''" @click="handleTab(2)">{{t('ai.toDoList')}}</el-button>
            </div>
            <span v-show="tabActive===2">{{t('ai.tips11')}}<span class="themeColor">{{t('ai.tips12')}} </span></span>
          </div>
          <todo-list
            v-if="tabActive===2&&moduleType==='ALL'"
            :navDynamic="navDynamic"
            :studentFileUploadList="studentFileUploadList"
            @toComplete="toComplete"
          ></todo-list>
          <div v-show="tabActive===1">
            <div class="result-title mb16 flex-center flex-space-between">
              <div class="flex-center">
                <img :src="image.ai" alt="">
                <span class="bold fs16 mr8">{{t('ai.aiResults')}}</span>
                <span class="themeColor fs12 word-wrap">({{t('ai.tips10')}})</span>
              </div>
              <span class="fs12">
                {{t('ai.percentageLength')}}
                (<span class="text-color3">{{unfinished}}</span>/{{fileList.length}})
              </span>
            </div>
            <div class="overflow">
              <div class="result-list mb16" v-for="(item,index) in fileList" :key="index">
                <div class="item-result mb16 flex-center">
                  <div class="flex-center" style="width:100%">
                    <div class="item1 mr16">
                      <img :src="image.pdf" v-show="getFileType(item.fileInfo,'pdf')">
                      <img :src="image.doc" v-show="getFileType(item.fileInfo,'doc')">
                      <img :src="image.xls" v-show="getFileType(item.fileInfo,'xls')">
                      <img :src="image.img" v-show="getFileType(item.fileInfo,'img')">
                      <img :src="image.nofile" v-show="getFileType(item.fileInfo,'nofile')">
                    </div>
                    <div style="width:100%">
                      <div class="flex-center">
                        <el-tooltip effect="light" placement="top-start" :content="item.fileInfo.fileNameOrc">
                          <span class="text-color1 mr8 file-Name">{{item.fileInfo.fileNameOrc}}</span>
                        </el-tooltip>
                        <span class="file-type flex-center mr8" v-show="item.typeKey!=='ALL'&&item.typeKey">
                          <img :src="image.ai" alt="" class="img-size">
                          <span>{{item.typeKey}}</span>
                        </span>
                        <span :class="getState(item)">{{item.percentageName}}</span>
                      </div>
                      <div>
                        <span class="text-color2 mr8">{{item.fileInfo.size}}</span>
                        <span class="text-color2 mr8" v-show="(item.cvResult===2||item.cvResult===0)&&item.costTime"> · {{item.costTime||0}}{{t('ai.seconds')}}</span>
                        
                        <span class="themeColor" v-show="item.cvResult===2&&getShowModuleType(item.typeKey)">
                          <div v-if="item.cvResDto&&item.cvResDto.length">
                            <p v-for="(cvItem,cvIndex) in item.cvResDto" :key="cvIndex" class="pointer"  @click="handlePreview(item,cvItem)">
                              {{item.typeKey}} {{cvIndex+1}} - {{t('ai.verifyFillInformation')}}
                            </p>
                          </div>
                          <div v-else class="pointer"  @click="handlePreview(item)">
                            {{t('ai.verifyFillInformation')}}
                          </div>
                        </span>
                      </div>
                      <el-progress :color="item.percentage<100?'#FF9600':'#92C96E'" :percentage="item.percentage"></el-progress>
                    </div>
                  </div>
                  <div class="flex-center">
                    <img :src="image.Frame2" class="img-size mr8" v-show="item.cvResult===2">
                    <img :src="image.refresh" class="img-size mr8 pointer" v-show="item.cvResult===0" @click="debounceInit(item)">
                    <img :src="image.delete" class="img-size pointer" @click="handleDelete(item.fileInfo)">
                  </div>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="(fileList.length&&unfinished!==fileList.length)?true:false"  @click="handleOneKeyAi" size="small">{{t('ai.oneKeyAi')}}</el-button>
        <el-button class="mr" @click="handleClose" size="small">{{t('ai.close')}}</el-button>
      </span>
    </el-dialog>
    <preview-all-form
      ref="previewAllForm"
      :aiAllData="aiAllData"
      @handleOverwrite="handleOverwrite"
    ></preview-all-form>
  </div>
</template>

<script>
import i18n from "@/locale/index";
import {setAiData} from '@/utils/session_storage.js'
import aiData from '/packages/components/ai/ai-data.js'
import todoList from './todoList.vue';
import previewAllForm from './preview-all-form.vue';
import { debounce } from '@/utils/tool.js'
import {
  getGeneralFileIdentificationStatusApi,
  deleteFileApi,
  retryGeneralFileIdentificationApi,
  getAiRecordApplyFormApi
} from "@/api/common.js";
export default {
  name: "aiUploadIeltsDialog",
  components: {
    todoList,
    previewAllForm
  },
  mixins: [i18n,aiData],
  inject: ['platformType','stuid'],
  props: {
    // 学生id
    studentId:{
      type: Number,
      default: 0,
    },
    // 上传模块
    moduleType:{
      type:String,
      default:'',
    },
    // 上传文件类型
    filesType:{
      type:Array,
      defalut:()=>[]
    },
    // 弹窗标题
    dialogTitle:{
      type:String,
      default:'',
    },
    at:{
      require: true,
      type: String,
      default: ""
    },
    navDynamic:{
      type: Array,
      defalut: () => []
    },
    studentFileUploadList:{
      type: Array,
      defalut: () => []
    },
  },
  computed:{
    // 设置上传的状态文字的颜色
    getState(){
      return(item)=>{
        let percentage=item.percentage;
        let cvResult=item.cvResult;
        let className = '';
        if(percentage===25||percentage===50||percentage===75){
          className='loading'
        }else if(percentage===100&&cvResult===0){
          className='fail'
        }else if(percentage===100&&cvResult===2){
          className='success'
        }
        return className;
      }
    },
    // 设置显示什么文件图标
    getFileType(){
      return(item,type)=>{
        const fileList=[
          {fileType:['pdf'],type:'pdf'},
          {fileType:['xls','xlsx'],type:'xls'},
          {fileType:['jpg','jpeg','png'],type:'img'},
          {fileType:['doc','docx'],type:'doc'},
          {fileType:['ALL'],type:'nofile'},
        ]
        let flag=false;
        for(const filData of fileList){
          if(filData.fileType.indexOf(item.fileTypeOrc.toLocaleLowerCase())!==-1&&type===filData.type){
            flag=true;
          }
        }
        return flag;
      }
    },
    // 上传文件中,showModuleType列表的类型才可以填写到表单的判断
    getShowModuleType(){
      return(typeKey)=>{
        return this.showModuleType.includes(typeKey)
      }
    }
  },
  data() {
    return {
      image:{
        upload:require('@/assets/ai-upload/upload.png'),
        ai:require('@/assets/ai-upload/AI.png'),
        pdf:require('@/assets/ai-upload/pdf.png'),
        doc:require('@/assets/ai-upload/doc.png'),
        xls:require('@/assets/ai-upload/xls.png'),
        img:require('@/assets/ai-upload/img.png'),
        nofile:require('@/assets/ai-upload/nofile.png'),
        Frame2:require('@/assets/ai-upload/Frame2.png'),
        refresh:require('@/assets/ai-upload/refresh.png'),
        delete:require('@/assets/ai-upload/delete.png'),
      },
      // 防抖
      debounceInit:debounce(this.handleReupload, 2000, true),
      isMinimize:false,
      // 进度
      percentage:0,
      // 进度文字
      percentageName:'',
      //弹窗显示
      isShow: false,
      // 是否上传文件
      showUploadFile:false,
      // 上传接口
      uploadApi:'/appFile/uploadStudentAiFile',
      // 上传附带参数
      uploadData:{
        type:'ISSUE-CENTER',
        stuId:this.stuid(),
        typeKey:'',
      },
      // ai识别结果
      // cvResult:ai识别状态0：识别失败,1：识别中,2：识别成功
      // costTime:ai识别时间（秒）
      aiResult:{},
      // 上传文件
      fileList:[],
      timer:null,
      // 上传大小
      fileSize:2,
      // 完成个数
      unfinished:0,
      // 允许浏览的模块类型
      showModuleType:['IELTS','CV','REFERENCE_LETTER','PTE','TOEFL-IBT'],
      // tab按钮:1:识别进度,2待办
      tabActive:2,
      // ai分析对象
      aiAllData:{},
    };
  },
  watch:{
    isShow:{
      handler(){
        if(this.isShow){
          this.checkTypeKey();
          this.setTimeGetResult(null,true);
        }else{
          this.tabActive='';
        }
      }
    }
  },
  methods: {
    // tab按钮
    handleTab(type){
      this.tabActive=type;
    },
    // 检查上传类型还是多文件上传
    checkTypeKey(){
      this.uploadData.typeKey=this.moduleType;
      this.tabActive=1;
      if(this.moduleType==='ALL'){
        // this.tabActive=2;
      }
    },
    // 上传前校验
    beforeUpload(file) {
      const fileTypes = this.filesType;
      const type = this.setFileType(file.name);
      // 文件大小 fileSize
      const is2M = file.size / 1024 / 1024 < this.fileSize;
      if (fileTypes.indexOf(type)===-1) {
        this.$msge.error(this.t('ai.tips6'));
        return false;
      }
      if (!is2M||file.size<=0) {
        this.$msge.error(this.t('ai.tips9'));
        return false;
      }
      this.showUploadFile=true;
      // 设置参数
      const setData=this.setFileListData();
      setData.fileInfo.fileTypeOrc=type;
      setData.fileInfo.fileNameOrc=file.name;
      setData.typeKey=null;
      setData.fileInfo.uid=file.uid;
      setData.fileInfo.size=this.setSize(file.size);
      // 设置进度
      const {percentage,percentageName}=this.setPercentage(25);
      setData.percentage=percentage;
      setData.percentageName=percentageName;
      this.fileList.unshift(setData)
      this.tabActive=1;
      return true;
    },
    // 设置上传列表的参数
    setFileListData(){
      return {
        typeKey:'',// 文件类型
        percentageName:'',
        percentage:0,
        cvResDto:{},
        costTime:0,
        cvResult:'',
        fileInfo:{
          fileNameOrc:'',// 文件名
          fileTypeOrc:'',// 文件后序类型
          fileGuid:'',// fileGuid:、已上传唯一标识
          uid:'',// uid:未上传的唯一标识
          size:0,// size:文件大小
        },
      }
    },
    // 设置进度
    setPercentage(percentage,cvResult){
      let percentageName='';
      if(percentage===25){
        percentageName=this.t('ai.percentage1');
      }else if(percentage===50){
        percentageName=this.t('ai.percentage2');
      }else if(percentage===75){
        percentageName=this.t('ai.percentage3');
      }else if(percentage===100&&cvResult===2){
        percentageName=this.t('ai.percentage4');
      }else if(percentage===100&&cvResult===0){
        percentageName=this.t('ai.percentage5');
      }
      return {percentage,percentageName}
    },
    // 上传成功
    successUpload(res, file){
      for(const item of this.fileList){
        if(item.fileInfo.uid===file.uid){
          item.fileInfo.fileGuid=res.datas[0].fileGuid;
          item.cvResult=1;
          // 设置进度
          const {percentage,percentageName}=this.setPercentage(50);
          item.percentage=percentage;
          item.percentageName=percentageName;
        }
      }
      this.setTimeGetResult(true,null);
    },
    // 定时器触发：noClear-需要清空列表，isNow-第一次打开弹窗需要用到
    async setTimeGetResult(noClear,isNow){
      this.stopTimer()
      if(isNow){
        await this.getAiResult();
      }
      this.timer=setInterval(()=>{
        this.timingGetAiResult(noClear);
      },3000)
    },
    // 定时获取ai状态,如果列表但凡一个未完成，都要保持定时调用获取状态
    timingGetAiResult(noClear){
      let keepTime=false;
      for(const item of this.fileList){
        if(item.cvResult===1){
          keepTime=true;
          break
        }
      }
      if(keepTime){
        this.getAiResult(noClear);
      }else{
        this.stopTimer()
      }
    },
    // 定时获取识别结果
    async getAiResult(noClear){
      this.aiResult={};
      const senData={
        businessFileType:this.moduleType,
        fkStudentId:this.stuid(),
      }
      const {data}=await getGeneralFileIdentificationStatusApi(senData);
      if(this.moduleType==='ALL'){
        if(data.code==='1003'&&data.data&&Object.keys(data.data).length){
          const reqData=data.data;
          this.fileList=[];
          this.unfinished=0;
          Object.keys(reqData).forEach((item)=>{
            if(reqData[item]&&reqData[item].length){
              for(const reqDataItem of reqData[item]){
                // 设置参数
                const setData = this.dataProcessing(reqDataItem)
                this.fileList.push(setData)
              }
            }
          })
        }else{
          if(!noClear){
            this.fileList=[];
            this.unfinished=0;
          }
        }
      }else{
        if(data.code==='1003'&&data.data&&data.data.length){
          const reqData=data.data;
          this.fileList=[];
          this.unfinished=0;
          reqData.forEach((item)=>{
            // 设置参数
            const setData = this.dataProcessing(item)
            this.fileList.push(setData)
          })
        }else{
          if(!noClear){
            this.fileList=[];
            this.unfinished=0;
          }
        }
      }
    },
    // 数据处理
    dataProcessing(reqDataItem){
      // 设置参数
      const setData=this.setFileListData();
      if(reqDataItem.cvResult===0||reqDataItem.cvResult===2){
        this.unfinished++;
        const {percentage,percentageName}=this.setPercentage(100,reqDataItem.cvResult);// 设置进度
        setData.percentage=percentage;
        setData.percentageName=percentageName;
        setData.possibleType=reqDataItem.possibleType
      }else if(reqDataItem.cvResult===1){
        const {percentage,percentageName}=this.setPercentage(75);// 设置进度
        setData.percentage=percentage;
        setData.percentageName=percentageName;
      }
      setData.costTime=reqDataItem.costTime;// 设置时间
      setData.cvResult=reqDataItem.cvResult;// 设置状态
      setData.typeKey=reqDataItem.typeKey;// 设置文件上传类型
      setData.cvResDto=reqDataItem.cvResDto// 识别内容对象
      
      // 设置文件参数
      if(reqDataItem.fileInfo){
        const fileInfo=JSON.parse(reqDataItem.fileInfo);
        setData.fileInfo=fileInfo
        setData.fileInfo.size=this.setSize(fileInfo.size);
        // setData.fileInfo.fileNameOrc=fileInfo.fileNameOrc;
        // setData.fileInfo.fileGuid=fileInfo.fileGuid;
        // setData.fileInfo.fileTypeOrc=this.setFileType(fileInfo.fileTypeOrc);
      }
      return setData
    },
    // 预览 把数据存放在session,然后在对应的地方获取，这样就不用传来传去了
    handlePreview(item,cvItem){
      let reqData={
        fileInfo:item.fileInfo?item.fileInfo:'',
        cvResDto:[],
        attachMap:[],
      };
      if(item.typeKey==='IELTS'||item.typeKey==='PTE'||item.typeKey==='TOEFL-IBT'){
        reqData.cvResDto=this.IELTSDataAi(item)
      }else if(item.typeKey==='REFERENCE_LETTER'){
        reqData.cvResDto=this.RefereerDataAi(item)
      }else if(item.typeKey==='CV'){
        reqData.cvResDto=this.CvDataAi(cvItem)
        reqData.attachMap=cvItem.attachMap;
      }
      setAiData(JSON.stringify(reqData))
      this.$emit('preview',item.typeKey);
      this.isShow=false;
    },
    // 去完成（待办任务）
    toComplete(item){
      this.$emit('toComplete',item);
      this.isShow=false;
    },
    stopTimer(){
      clearInterval(this.timer);
      this.timer=null;
    },
    // 重新识别
    async handleReupload(item){
      const fileGuid=item.fileInfo.fileGuid;
      const {data}=await retryGeneralFileIdentificationApi({fileGuid})
      if(data.code==='1003'){
        this.setTimeGetResult(null,true);
      }
    },
    // AI分析文件
    async handleOneKeyAi(){
      if(this.fileList&&!this.fileList.length){
        return;
      }
      const {data}=await getAiRecordApplyFormApi({studentId:this.stuid()});
      if(data.code==='1003'){
        this.aiAllData=data.data;
        const el=this.$refs.previewAllForm;
        el.isShow=true;
      }
    },
    // 删除文件
    async handleDelete(data){
      if(data.fileGuid){
        await deleteFileApi(data.fileGuid);
      }
      this.fileList.forEach((item,index)=>{
        if(data.fileGuid===item.fileInfo.fileGuid){
          this.fileList.splice(index,1)
          this.unfinished--;
        }
      })
    },
    // 清空
    clear(){
      this.fileList=[];
      this.aiResult={};
      this.stopTimer();
    },
    handleClose(){
      let checkUploading=false;
      for(const item of this.fileList){
        if(item.percentage<=25){
          checkUploading=true;
        }
      }
      this.$emit('refreshAttach')
      // 如果有上传中则最小化，否则关闭
      if(checkUploading){
        this.isMinimize=true;
      }else{
        this.clear();
        this.isShow=false;
      }
    },
    // 一键覆盖成功
    handleOverwrite(){
      this.clear();
      this.isShow=false;
      this.$emit('handleOverwrite')
    },
    // 设置size格式
    setSize(size){
      return size?((size / 1024).toFixed(1))+'K':0+'K';
    },
    // 获取上传文件的类型
    setFileType(val){
      return val?val.substring(val.lastIndexOf('.') + 1).toLocaleLowerCase():'';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/style/varibale.scss";
.themeColor{
  color:#ff9700;
}
.mb16{
  margin-bottom: 16px;
}
.mb8{
  margin-bottom: 8px;
}
.mr16{
  margin-right: 16px;
}
.mr8{
  margin-right: 8px;
}
.bold{
  font-weight: bold;
}
.text-color1{
  color:#31373D;
}
.text-color2{
  color:#858585;
}
.text-color3{
  color:#38B865;
}
.success,.loading,.fail{
  padding: 2px 6px;
  border-radius: 4px;
}
.success{
  color:#38B865;
  background: #E6FFE0;
}
.loading{
  color:#FF9600;
  background: #FFF5E5;
}
.fail{
  color: #E84C57;
  background: #FFEDEE;
}
.flex-center{
  display: flex;
  align-items: center;
}
.flex-space-between{
  justify-content: space-between
}
.pointer{
  cursor: pointer;
}
.fs12{
  font-size: $fs12;
}
.fs16{
  font-size: $fs16;
}
@media screen and(max-width: 768px){
/deep/ .el-dialog {
  width: calc(100% - 20px) !important;
  margin: 10px !important;
  min-width: unset;
  padding: 0 12px;
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__header{
    text-align: center;
  }
}
}
</style>
<style lang="scss">
.aiUploadIELTS-box{
  >.el-dialog__body{
    padding-top:0 !important;
    padding-bottom: 0 !important;
  }
  >.el-dialog__header{
    text-align: left !important;
    span{
      font-weight: bold;
    }
  }
  >.el-dialog__footer{
    text-align: center;
    padding:10px;
  }
  .upload-file{
    width:100%;
    >.el-upload--text{
      width:100%;
      >.el-upload-dragger{
        width:100%;
        height:auto
      }
    }
  }
  .drag-box{
    width:100%;
    justify-content: center;
    border:1px dashed #ccc;
    background: #FEFCFA;
    padding:15px 30px;
    img{
      width:48px;
      height:44px;
      margin-right:24px;
    }
  }
  .file-result{
    .todo-tab{
      text-align: left;
    }
    .overflow{
      max-height:350px;
      overflow: auto;
    }
    .result-title{
      img{
        width:25px;
        height:25px;
        margin-right:5px;
      }
    }
    .result-loading{
      width:50%;
      margin:0 auto;
      img{
        width:100%;
      }
      p{
        font-size: 18px;
        color: #666;
        font-weight: 500;
      }
    }
    .result-list{
      text-align: left;
      .item-result{
        padding:8px;
        border:1px dashed #ccc;
        justify-content: space-between !important;
        .img-size{
          width:18px;
          height:18px;
        }
        .file-type{
          padding: 2px 6px;
          border-radius: 4px;
          background: #FFF5E5;
          color: #FF9600;
        }
        .file-Name{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          max-width:120px;
        }
        .item1{
          height:44px;
          img{
            height:100%;
          }
        }
      }
    }
    
  }
}
.word-wrap{
  word-break: break-all;
  word-break: break-word;
}
</style>